/** Superficie pública de shared/theme. */
export { colors } from './colors';
export { ticketColors, ticketFonts } from './ticketColors';
export { spacing } from './spacing';
export { typography } from './typography';
export { status as statusColors, brand, semantic } from '@vuelto/tokens';
export {
  WEB_DARK_SCROLL_CLASS,
  WEB_TEAL_RAIL_SCROLL_CLASS,
  ensureWebDarkScrollbarStyles,
  webDarkScrollProps,
  webTealRailScrollProps,
  withWebDarkScrollStyle,
  withWebTealRailScrollStyle,
  webOperationalScrollBindings,
  webTealRailScrollBindings,
  webDarkScrollStyle,
  webTealRailScrollStyle,
} from './webScrollbar';
export { webTextInputAutofillStyle } from './webTextInput';
